import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import UserCard from '@components/ConnectionCard';
import CommunityActions from '~/actions/community';

const Recommended = ({ user, connections }) => {
    const dispatch = useDispatch();

    const recommendedUsers = connections ? connections.slice(0, 4) : [];

    const handleConnect = (connectUser) => () => {
        const payload = { user_id: user.id, connect_user_id: connectUser.id };
        const after = { type: 'GETCOMMUNITYCONNECTIONS_REQUEST', payload: { user_id: user.id } };
        dispatch(CommunityActions.postcommunityconnectRequest(payload, null, after, null));
    };

    const handleOpenDetail = (connectUser) => () => {
        const payload = { userId: connectUser.id };
        dispatch(CommunityActions.getcommunityuserRequest(payload, null, `/${connectUser?.slug}/about`));
    };

    return (
        <Row className="connections-received-request mx-1">
            {recommendedUsers.map((connectUser) => (
                <Col key={connectUser.id} className="p-2" xs={12} sm={6} md={3}>
                    <UserCard data={connectUser} tab="recommended" onClick={handleConnect(connectUser)} onOpen={handleOpenDetail(connectUser)} />
                </Col>
            ))}
            {recommendedUsers.length === 0 && <p className="dsl-b16 p-3">No recommended users</p>}
        </Row>
    );
};

Recommended.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.number,
    }),
    connections: PropTypes.array,
};

Recommended.defaultProps = {
    user: {
        id: 0,
    },
    connections: [],
};

export default Recommended;
